import React, { Component } from 'react';
// import Transition from 'react-transition-group/Transition';

// import styles from './transition-handler.module.css';

class TransitionHandler extends Component {

	/* bad, but works */
	shouldComponentUpdate(prevProps) {
		return this.props.location.pathname === window.location.pathname;
	}

	render() {
    const { in: inProps, children, state } = this.props;

    return children;
    // return <span></span>;
	}
}

export default TransitionHandler;


// WEBPACK FOOTER //
// ./src/components/TransitionHandler/TransitionHandler.js